import { render, staticRenderFns } from "./ProductPublicPrices.vue?vue&type=template&id=2ad1130a&scoped=true&"
import script from "./ProductPublicPrices.vue?vue&type=script&lang=js&"
export * from "./ProductPublicPrices.vue?vue&type=script&lang=js&"
import style0 from "./ProductPublicPrices.vue?vue&type=style&index=0&id=2ad1130a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad1130a",
  null
  
)

export default component.exports